import * as React from 'react'
import styled from 'styled-components'
import Group from 'components/utils/Group'
import ClickableListItem from 'LuxKit/List/ClickableListItem'

const _VerticalLayout = styled(Group)`
  width: 100%;
  height: 100%;
  flex: 1 1 0;

  & > * + * {
    border-top: 1px solid ${({ theme }) => theme.palette.neutral.default.five};
  }
`

export function VerticalLayout(props: Omit<React.ComponentProps<typeof Group>, 'direction'>) {
  return <_VerticalLayout {...props} direction="vertical" />
}

const _HorizontalLayout = styled(Group)`
  width: 100%;
  height: 100%;
  flex: 1 1 0;

  & > * + * {
    border-left: 1px solid ${({ theme }) => theme.palette.neutral.default.five};
  }
`

export function HorizontalLayout(props: Omit<React.ComponentProps<typeof Group>, 'direction'>) {
  return <_HorizontalLayout {...props} direction="horizontal" />
}

export const Sidebar = styled.div`
  flex: 0 0 auto;
  overflow-y: auto;
`

export const Topbar = styled.div`
  flex: 0 0 auto;
  overflow-x: auto;
`

export const Content = styled.div`
  flex: 1 1 0;
  overflow-y: auto;
`

export const MenuItem = styled(ClickableListItem)`
  &:not(:disabled):focus {
    outline: 0;
  }
`
